import { FaPhoneAlt, FaFacebookF } from "react-icons/fa";
import { SiZalo } from "react-icons/si";

const FloatingContact = () => {
  return (
    <div className="fixed bottom-5 right-5 flex flex-col gap-4 z-50">
      
      {/* FACEBOOK */}
      <a
        href="https://www.facebook.com/accordthemoonhotels"
        target="_blank"
        rel="noopener noreferrer"
        className="w-16 h-16 rounded-full 
        bg-gradient-to-br from-blue-500 to-blue-600
        flex items-center justify-center
        shadow-lg shadow-blue-300/50
        transform transition-all duration-300
        hover:scale-110 hover:shadow-2xl hover:shadow-blue-400/80
        animate-bounce-slow"
      >
        <FaFacebookF size={28} className="text-white animate-pulse" />
      </a>

      {/* ZALO */}
      <a
        href="https://zalo.me/0933537986"
        target="_blank"
        rel="noopener noreferrer"
        className="w-16 h-16 rounded-full 
        bg-[#0068ff]
        flex items-center justify-center
        shadow-lg shadow-blue-400/50
        transform transition-all duration-300
        hover:scale-110 hover:shadow-2xl hover:shadow-blue-500/80
        animate-bounce-slow"
      >
        <SiZalo size={30} className="text-white animate-pulse" />
      </a>

      {/* PHONE */}
      <a
        href="tel:0933537986"
        className="w-16 h-16 rounded-full 
        bg-green-400
        flex items-center justify-center
        shadow-lg shadow-green-300/50
        transform transition-all duration-300
        hover:scale-110 hover:shadow-2xl hover:shadow-green-400/80
        animate-bounce-slow"
      >
        <FaPhoneAlt size={24} className="text-white animate-pulse" />
      </a>

    </div>
  );
};

export default FloatingContact;
